import axios from "axios";
import { useMutation, useQuery } from "react-query";
import {
    restoreAccessToken,
    secureAxios,
    secureBotAxios,
} from "../_helpers/auth";
import { queryClient } from "../_helpers/query";
import log from "cslog";

// export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === "true";
export const IS_LOCAL = false;

export const botAxios = axios.create({
    baseURL: IS_LOCAL ? "http://localhost:2500/" : "https://botapi.qureal.com/",
    headers: {},
});

export const botLocalAxios = axios.create({
    baseURL: "http://localhost:2500/",
    headers: {
        Authorization: `Bearer ${restoreAccessToken()}`,
    },
});

export const botSecureAxios = axios.create({
    baseURL: IS_LOCAL ? "http://localhost:2500/" : "https://botapi.qureal.com/",
    headers: {
        Authorization: `Bearer ${restoreAccessToken()}`,
    },
});

export const useBotEndpontGet = (path, params = null, enabled = true) => {
    return useQuery(
        [path, params],
        () => {
            if (!path) return null;
            return botSecureAxios.get(path, { params }).then((res) => {
                return res?.data;
            });
        },
        {
            enabled: !!path && !!enabled,
        }
    );
};

export const useBotEndpoint = (path, onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios.post(path, data).then((res) => {
                return res?.data;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
            onDone: (result, variables, context) => {
                onDone(result);
            },
        }
    );
};

export const useUploadMedia = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return (
                botSecureAxios
                    // .post(`/social_post/upload_media`, data)
                    .post(`/social_post/upload_media_new`, data)
                    .then((res) => {
                        return res?.data;
                    })
            );
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
            onDone: (result, variables, context) => {
                onDone(result);
            },
        }
    );
};

export const useGeneratePreset = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/gen/generate_preset`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useAnalyseDataSource = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/trends/analyse_source`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};
export const useGenerateBio = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios.post(`/social/get_bio`, data).then((res) => {
                return res?.data?.data?.content;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useSchedulePostNew = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/social_post/approve_post/${data.id}`, data.data)
                .then((res) => {
                    return res;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                // setTimeout(() => {
                //     queryClient.invalidateQueries([
                //         "items",
                //         "qdb_calendar_entries",
                //     ]);
                // }, 2000);
            },
            onDone: (result, variables, context) => {
                onDone(result);
            },
        }
    );
};

export const useSchedulePost = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            const body = {
                post_status: data.post_status,
                output_format: data.output_format,
                social_account_id: data.social_account_id,
                platform: data.platform,
            };
            return botSecureAxios
                .post(`/render/approve_entry/${data.id}`, body)
                .then((res) => {
                    return res;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries([
                        "items",
                        "qdb_calendar_entries",
                    ]);
                }, 1000);
            },
        }
    );
};
export const useCancelScheduledPost = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/social_post/cancel_post/${data.id}`, data.data)
                .then((res) => {
                    return res;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries([
                        "items",
                        "qdb_calendar_entries",
                    ]);
                }, 1000);
            },
        }
    );
};
export const useReschedulePost = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            const body = {
                date: data.date,
                platform: data.platform,
            };
            return botSecureAxios
                .post(`/render/reschedule/${data.id}`, body)
                .then((res) => {
                    return res;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries([
                        "items",
                        "qdb_calendar_entries",
                    ]);
                }, 2000);
            },
        }
    );
};
export const useImageUpload = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios.post(`/upload_image`, data).then((res) => {
                return res;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useGenImage = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            // return botLocalAxios
            return botSecureAxios.post(`/q0/gen_image`, data).then((res) => {
                return res?.data;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};

export const useAddEvent = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios.post(`/gen/add_event`, data).then((res) => {
                return res?.data;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries([
                        "items",
                        "qdb_calendar_entries",
                    ]);
                    // if (extra_invalidate) {
                    //     queryClient.invalidateQueries(extra_invalidate);
                    // }
                }, 3000);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};

export const useCalendarOutline = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            // return botLocalAxios
            return botSecureAxios
                .post(`/gen/calendar_outline`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};

export const useXTrendsGeneration = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/trends/get_new_trends`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};

export const useTrendIdeaGeneration = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/gen/process_raw_idea`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};

export const useNewPresetGeneration = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/gen/preset_by_id`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useActualTrendIdeaGeneration = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/trends/idea_generation`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};
export const useGenerateModelFromImages = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios.post(`/aimodel/create`, data).then((res) => {
                return res;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useProcessIdea = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/gen/process_idea/${data.id}`)
                .then((res) => {
                    return res;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};

export const useGetTrends = (data, enabled) => {
    return useQuery(
        ["items", "ai_trends", data],
        () =>
            botAxios
                .get(`/trends/get_trends`, {
                    params: data,
                })
                .then((res) => res.data?.data),
        {
            enabled: enabled,
            // keepPreviousData: false,
        }
    );
};
export const useCalStrategy = (onSuccess, onDone = () => {}) => {
    return useQuery(["cal_strategy"], () => {
        return botSecureAxios.get(`/gen/cal_strategy`).then((res) => {
            return res?.data?.data?.strategy;
        });
    });
};
export const useBGRemove = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return (
                botAxios
                    // .post(`/image/remove_bg_from_name`, data, {
                    .post(`/image/remove_bg_and_crop_by_name`, data, {
                        headers: {
                            Authorization: `Bearer ${restoreAccessToken()}`,
                        },
                    })
                    .then((res) => {
                        return res;
                    })
            );
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                queryClient.invalidateQueries("photos");
            },
            onSettled: (data) => {
                onDone();
            },
        }
    );
};

export const useSmartCrop = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botAxios
                .post(`/image/crop_from_name`, data, {
                    headers: {
                        Authorization: `Bearer ${restoreAccessToken()}`,
                    },
                })
                .then((res) => {
                    return res;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                queryClient.invalidateQueries("photos");
            },
            onSettled: (data) => {
                onDone();
            },
        }
    );
};

export const useGenerateTemplateSuggestions = (
    onSuccess,
    onDone = () => {}
) => {
    return useMutation(
        (data) => {
            return botAxios
                .post(`/gen/prompt_to_suggestions`, data, {
                    headers: {
                        Authorization: `Bearer ${restoreAccessToken()}`,
                    },
                })
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useAIImageGenerator = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botAxios.post("/image/gen", data, {
                headers: {
                    Authorization: `Bearer ${restoreAccessToken()}`,
                },
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result?.data || {}, variables, context);
            },
            onSettled: (data) => {
                onDone();
            },
        }
    );
};

export const useGenerateTempatePresetFromInput = (
    onSuccess,
    onDone = () => {}
) => {
    return useMutation(
        (data) => {
            return botAxios
                .post(`/gen/generate_preset_data`, data, {
                    headers: {
                        Authorization: `Bearer ${restoreAccessToken()}`,
                    },
                })
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useGenerateTemplatePreset = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return (
                botAxios
                    // .post(`/gen/generate_template_presets`, data, {
                    .post(`/gen/generate_template_presets_new`, data, {
                        headers: {
                            Authorization: `Bearer ${restoreAccessToken()}`,
                        },
                    })
                    .then((res) => {
                        return res?.data;
                    })
            );
        },
        {
            onSuccess: (result, variables, context) => {
                log.d(result, "result in useGenerateTemplatePreset");
                onSuccess(result);
            },
        }
    );
};

export const useAutoTagTemplate = (item, enabled) => {
    const text = `
    ${item.title}
    `;
    return useQuery(
        ["ai", "tags", item?.id],
        () =>
            botAxios
                .post(`/gen/get_template_tags`, { text: text })
                .then((res) => res.data?.data),
        {
            enabled: enabled,
        }
    );
};

export const useAutoTagTemplateMutation = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            const text = `
            ${data.title}
            `;
            return botAxios
                .post(`/gen/get_template_tags`, { text: text })
                .then((res) => {
                    return res?.data?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useAIStudioPerson = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botAxios
                .post(`/studio/generate_person`, data, {
                    headers: {
                        Authorization: `Bearer ${restoreAccessToken()}`,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                onDone();
            },
        }
    );
};

export const useAddTestOrgs = (onSuccess, onDone = () => {}) => {
    return useMutation(
        () => {
            // return botSecureAxios
            return secureBotAxios
                .post(`/proxies/editor/add_test_orgs`, {})
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                queryClient.invalidateQueries(["user"]);
                queryClient.invalidateQueries(["items", "qdb_organization"]);
                onSuccess(result);
            },
        }
    );
};

export const useSpotlightSearch = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botAxios.post(`/spotlight/search`, data).then((res) => {
                return res?.data;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useThemeGenerator = (is_local, onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return is_local
                ? botLocalAxios.post(`/gen/color_palette`, data).then((res) => {
                      return res?.data;
                  })
                : botAxios.post(`/gen/color_palette`, data).then((res) => {
                      return res?.data;
                  });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useThemeGeneratorFromLogo = (
    is_local,
    onSuccess,
    onDone = () => {}
) => {
    return useMutation(
        (data) => {
            return is_local
                ? botLocalAxios.post(`/gen/logo_palette`, data).then((res) => {
                      return res?.data;
                  })
                : botAxios.post(`/gen/logo_palette`, data).then((res) => {
                      return res?.data;
                  });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useFillColorInDesign = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return (
                botSecureAxios
                    // .post(`/q0/fill_color_in_design`, data)
                    .post(`/q0/update_color_in_design`, data)
                    .then((res) => {
                        return res?.data;
                    })
            );
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};

export const useRandomTemplatesNew = (
    preset,
    primary_tag,
    fields,
    limit,
    enabled
) => {
    return useQuery(
        ["random_templates_new", preset, primary_tag, fields, limit],
        () =>
            secureAxios
                .get(
                    `/qe_pro_db/randomize?${
                        preset && !primary_tag ? `preset=${preset}&` : ""
                    }${
                        primary_tag ? `primary_tag=${primary_tag}&` : ""
                    }&fields=${fields}&limit=${limit}`
                )
                .then((res) => res?.data),
        {
            enabled: enabled,
        }
    );
};

export const useRandomTemplates = (collection, query_string, enabled) => {
    return useQuery(
        ["random_templates", collection, query_string],
        () =>
            botAxios
                .get(`/spotlight/randomize/${collection}?${query_string}`)
                .then((res) => res?.data?.data),
        {
            // staleTime: 1000 * 60 * 60 * 5,
            enabled: enabled,
        }
    );
};

export const useGenMultipage = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botAxios.post(`/gen/multipage_data`, data).then((res) => {
                return res?.data;
            });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
        }
    );
};
//new for the raw image generation
export function useAIStudioRawImage(onSuccess) {
    return useMutation(
        (data) => {
            console.log(" RAW API mutate called with:", data);

            return botAxios
                .post("/q0/gen_image", data, {
                    headers: {
                        Authorization: `Bearer ${restoreAccessToken()}`,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    console.log(" RAW API response:", res);
                    return res.data;
                })
                .catch((err) => {
                    console.error(" RAW API error:", err);
                    throw err;
                });
        },
        {
            onSuccess: (data) => {
                console.log(" RAW mutation onSuccess:", data);
                onSuccess(data);
            },
            onError: (error) => {
                console.error(" RAW mutation onError:", error);
            },
        }
    );
}

export const useGenQ0P1 = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/q0/generate_q0_p1`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
            },
            onSettled: () => {
                onDone();
            },
        }
    );
};

export const useGetFeatureFlags = () => {
    return useQuery(
        ["feature_flags"],
        () =>
            botSecureAxios
                .get(`/proxies/editor/feature_flags`)
                .then((res) => res?.data),
        {
            staleTime: 1000 * 60 * 5, // Cache for 5 minutes
            cacheTime: 1000 * 60 * 10, // Maintain in cache for 10 minutes
            retry: 2,
            refetchOnWindowFocus: false, // Prevent unnecessary refetches
        }
    );
};
